/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/bubble-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 66.5 133',
    data: '<g data-name="Layer 2"><path pid="0" d="M66.5 133A66.5 66.5 0 010 66.5 66.5 66.5 0 0166.5 0z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
